import { render } from "./UhrKonfig.vue?vue&type=template&id=79433236"
import script from "./UhrKonfig.vue?vue&type=script&lang=js"
export * from "./UhrKonfig.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__